<template>
  <VaDropdown v-model="open" placement="bottom-end" stick-to-edges>
    <template #anchor>
      <VaButton preset="secondary" color="textPrimary" class="layout-trigger" aria-label="Tùy chỉnh bố cục" title="Tùy chỉnh bố cục">
        <VaIcon name="view_quilt" size="large" />
      </VaButton>
    </template>
    <VaDropdownContent class="layout-menu">
      <strong>Tùy chỉnh bố cục</strong>
      <button type="button" :class="{ active: mode === 'vertical' }" @click="choose('vertical')"><VaIcon name="view_sidebar" />Menu dọc<span v-if="mode === 'vertical'">✓</span></button>
      <button type="button" :class="{ active: mode === 'horizontal' }" @click="choose('horizontal')"><VaIcon name="view_day" />Menu ngang<span v-if="mode === 'horizontal'">✓</span></button>
    </VaDropdownContent>
  </VaDropdown>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { useLayoutMode, type LayoutMode } from '../../../composables/useLayoutMode'

const { mode, setMode } = useLayoutMode()
const open = ref(false)
function choose(value: LayoutMode) {
  setMode(value)
  open.value = false
}
</script>

<style scoped>
.layout-trigger { min-width: 36px; padding: 0 .4rem; }
.layout-menu { display: grid; gap: .25rem; min-width: 220px; padding: .65rem; background: var(--va-background-element); color: var(--va-text-primary); }
.layout-menu strong { padding: .4rem .55rem; font-size: .82rem; }
.layout-menu button { display: flex; align-items: center; gap: .6rem; padding: .55rem; border: 0; border-radius: 6px; background: transparent; color: inherit; text-align: left; cursor: pointer; }
.layout-menu button:hover, .layout-menu button.active { background: var(--va-background-secondary); color: var(--va-primary); }
.layout-menu button span { margin-left: auto; }
</style>
